<div class="flex grow w-full">
    <div class="flex flex-col gap-2 w-full">
        <div class="text-base font-bold pt-1">
            {{ task.taskName }}
        </div>
        <div class="flex flex-row gap-2 w-full">
            <div class="flex flex-col gap-2">
                <!-- Run Task -->
                <task-run [task]="task"></task-run>
                <!-- Schedules -->
                <div class="text-base font-bold">
                    Schedules
                </div>
                <task-schedule-table [task]="task"></task-schedule-table>
                <!-- History -->
                <div class="text-base font-bold">
                    History
                </div>
                <task-history-table [task]="task"></task-history-table>
            </div>
        </div>
    </div>
</div>